
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/es5/locale/es'
//import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { es },
        current: 'es'
    },
    theme: {
        themes: {
            light: {
                primary: "#670069",
                // primary: "#b6a100",
                background: "#F6F8FE",
            }
        }
    }
});
